import { Block, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../../types.ts';
import { EditableDateField } from '../EditableDateField.tsx';
import { readOnlyFieldTypographyProps } from '../styles.ts';
import { PropertyGridFieldProps } from '../types.ts';

type ConditionalDateFieldProps = PropertyGridFieldProps & {
  statusFieldName: FieldPath<PropertyGridForm>;
  allowedStatuses: string[];
};

const ConditionalDateField = ({
  columnIndex,
  field,
  control,
  getValues,
  setValue,
  colSpan,
  statusFieldName,
  allowedStatuses,
}: ConditionalDateFieldProps) => {
  const status = useWatch({ control, name: statusFieldName }) as string | undefined;

  if (status && !allowedStatuses.includes(status)) {
    return (
      <Block gridColumn={`span ${colSpan}`}>
        <Typography {...readOnlyFieldTypographyProps}>-</Typography>
      </Block>
    );
  }

  return (
    <EditableDateField
      columnIndex={columnIndex}
      field={field}
      control={control}
      getValues={getValues}
      setValue={setValue}
      colSpan={colSpan}
    />
  );
};

export const SoldDateField = ({ columnIndex, ...props }: PropertyGridFieldProps) => (
  <ConditionalDateField
    {...props}
    columnIndex={columnIndex}
    statusFieldName={
      `columns.${columnIndex}.propertyData.editableData.transaction.status` as FieldPath<PropertyGridForm>
    }
    allowedStatuses={['SettledSale']}
  />
);

export const ContractDateField = ({ columnIndex, ...props }: PropertyGridFieldProps) => (
  <ConditionalDateField
    {...props}
    columnIndex={columnIndex}
    statusFieldName={
      `columns.${columnIndex}.propertyData.editableData.transaction.status` as FieldPath<PropertyGridForm>
    }
    allowedStatuses={['SettledSale', 'Contract']}
  />
);

export const LeaseDateField = ({ columnIndex, ...props }: PropertyGridFieldProps) => (
  <ConditionalDateField
    {...props}
    columnIndex={columnIndex}
    statusFieldName={
      `columns.${columnIndex}.propertyData.editableData.transaction.rentalListingStatus` as FieldPath<PropertyGridForm>
    }
    allowedStatuses={['Rented']}
  />
);
